export default (nameMap, nameList) => {
  return Object.keys(nameMap).filter(name => {
    return nameMap[name];
  }).concat(nameList)
    .filter(Boolean)
    .join(' ');
};
